import { Typography } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid';

export default function SelectionCounter({
  selectionModel,
  allCount,
}: {
  selectionModel: GridRowSelectionModel;
  allCount: number;
}) {
  if (allCount === 0) {
    return <></>;
  }
  let selectionCount;
  if (selectionModel.type === 'include') {
    selectionCount = selectionModel.ids.size;
  } else {
    selectionCount = allCount - selectionModel.ids.size;
  }
  return (
    <Typography variant="body2">
      ({selectionCount}/{allCount})
    </Typography>
  );
}
